import { useMutation } from '@apollo/client';
import useSnackBars from './useSnackBars';
import REQUEST_CREDIT_LINE_SUBLINE_AND_PRE_OFFER_EVALUATION from '../graphql/mutations/request-credit-line-subline-and-preoffer-evaluation';

const useRequestCreditLineSublineAndPreOfferEvaluation = (
  onSuccess = () => null,
  onError = () => null,
) => {
  const { addAlert } = useSnackBars();

  const [requestCreditLineSublineAndPreOfferEvaluation, { loading }] = useMutation(
    REQUEST_CREDIT_LINE_SUBLINE_AND_PRE_OFFER_EVALUATION,
    {
      onCompleted: (data) => {
        const warningCode = data?.requestCreditLineSublineAndPreOfferEvaluation?.warningCode;
        onSuccess(warningCode);
      },
      onError: (error) => {
        onError(error);
        addAlert({
          id: 'credit-line-subline-preoffer-evaluation-error',
          message: 'Parece que ha ocurrido un error al enviar la solicitud de evaluación de línea y facturas. Por favor, ponte en contacto con tu ejecutivo.',
        });
      },
    },
  );

  const evaluate = (invoiceIds, debtorRuts = []) => {
    requestCreditLineSublineAndPreOfferEvaluation({
      variables: {
        invoiceIds,
        debtorRuts: debtorRuts.length > 0 ? debtorRuts : null,
      },
    });
  };

  return {
    requestCreditLineSublineAndPreOfferEvaluation: evaluate,
    loading,
  };
};

export default useRequestCreditLineSublineAndPreOfferEvaluation;
